import React, { useState } from 'react';
import '../Tech/TechClientsCollaborations.css';
import govKarnatakaImg from '../../Assets/health/healthfounder.png';
import procurementVendorImg from '../../Assets/tech/techaccordian1.png';
import mapsErpImg from '../../Assets/tech/techaccordian1.png';
import samruddhiImg from '../../Assets/tech/techaccordian1.png';
import aQracImg from '../../Assets/tech/techaccordian1.png';
import vcnrLogo from '../../Assets/vcnr-logo-white.png';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const BuildersClientsCollaborations = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const projects = [
    {
      title: 'Nelamangala Community Hospital',
      description: `A landmark public health investment with adaptive design and 24x7 services.`,

      links: [
        { url: 'vcnrtech.com', label: 'Book a Site Visit' },
        { url: 'bxontech.com', label: 'Download PDF Portfolio' },
      ],
      image: govKarnatakaImg 
    },
    {
      title: 'Sunrise Township',
      description: `A peaceful residential community built around green spaces and community living.`,
      links: [
        { url: 'reqwise.com', label: 'reqwise.com' },
        { url: 'vendorsuite.com', label: 'vendorsuite.com' }
      ],
      image: procurementVendorImg
    },
    {
      title: 'TechPark @ Bengaluru',
      description: `High-efficiency workspace fitted with smart tech, solar power, and rapid occupancy timelines.`,
      links: [
        { url: 'maps-erp.com', label: 'maps-erp.com' }
      ],
      image: mapsErpImg
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className='clients-collab__wrapper'>
    <div className="clients-collab__section">
      <div className="clients-collab__header">
        <h2 className="clients-collab__title">Project Highlights</h2>
        <h3 className="clients-collab__subtitle">Building a Legacy: Projects by a Premier <br />Construction Company in India</h3>
        <p className="clients-collab__description">
          At VCNR Builders & Infrastructure, we collaborate with visionary clients who believe that great structures go beyond design — they define progress. Our projects span industries and communities, yet share one common goal: building smarter, sustainable spaces that stand the test of time.
        </p>
      </div>

      <div className="clients-collab__accordion">
        {projects.map((project, index) => (
          <div key={index} className="clients-collab__item">
            <button
              className={`clients-collab__toggle ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              {project.title}
              <span className="clients-collab__arrow">{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
            </button>
            {activeIndex === index && (
              <div className="clients-collab__details">
                <div className="clients-collab__details-inner">
                  <img
                    className="clients-collab__image"
                    src={project.image}
                    alt={project.title}
                  />
                  <div className="clients-collab__text">
                    <h4 className="clients-collab__project-title">{project.title}</h4>
                    <div className="clients-collab__highlight-bar"></div>
                    <img src={vcnrLogo} alt="VCNR Logo" className="clients-collab__brand"/>
                    <p className="clients-collab__project-description">{project.description}</p>
                    <div className="clients-collab__links">
                      {project.links.map((link, i) => (
                        <a
                          key={i}
                          href={`https://${link.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="clients-collab__link"
                        >
                          {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default BuildersClientsCollaborations;
